import React, { useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { usePagesState, GetPrivacyPolicy } from '../../context/PagesContext';

//global css
import "../../static/css/global.css";


const PrivacyPolicy = () => {

  const context = usePagesState();

  useEffect(() => {
    GetPrivacyPolicy(context.setprivacyData)
  }, []);

  useEffect(() => {
    if (context.privacyData.privacyData.data && context.privacyData.privacyData.data.content) {

      let htmlData = context.privacyData.privacyData.data.content;
      document.getElementById("content").innerHTML = htmlData;
      
    }
  }, [context.privacyData.privacyData.data])


  return (
    <>
      <div className='maincontent'>
        <div className='content' id='content'>
        </div>
      </div>
    </>
  );
}

export default withRouter(PrivacyPolicy);